import { Aspect } from '@teambit/harmony';

export const EjectAspect = Aspect.create({
  id: 'teambit.workspace/eject',
});
